// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8b93b91a","455":"d5a9283d","977":"78249c30"}[chunkId] + ".chunk.js";
};